import { React, useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { GetUserList } from '../../Services/user';
import { ActivityUser } from '../../Services/user'
import { useDispatch } from 'react-redux';
import Loader from '../../Global/loader'
import './Index.scss'
import SVG from "react-inlinesvg";
import DangerSVG from './../../Images/svg/usklicnik.svg'

const Activate = (data) => {
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [id] = useState(data.data.id);
    const [isActive] = useState(data.data.activity === "ACTIVE" ? true : false)
    const dispatch = useDispatch();

    const handleShow = async () => {
        setLoading(true);
        setShow(true);
        setLoading(false);
    }
    const handleClose = () => {
        setShow(false);
    }

    const handleSubmit = async (event) => {
        await setLoading(true);
        try{
            await ActivityUser(dispatch, { id, isActive });
            await GetUserList(dispatch, null, null)
            await setShow(false);
        }
        catch{
        }

        await setLoading(false);
    }

    return (
        <>
        <Button  variant="flat" className="btn" bsPrefix={!isActive ? "edit" : "delete"} onClick={handleShow}>
            {isActive ? "Deaktiviraj" : "Aktiviraj"}
        </Button>

        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            className="add-modal"
            centered
            size="sm"
        >
        {!loading ?
            <>
               
                <Form noValidate  onSubmit={handleSubmit}>
                    <Modal.Body>
                       <div style={{textAlign: "center", color:"white"}}>
                           <span> <SVG src={DangerSVG} /> Potvrdi {!isActive ? "aktivaciju" : "deaktivaciju"} korisnika </span>
                       </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="flat" className="btn" bsPrefix="edit" type="submit">
                            {!isActive ? "Aktiviraj" : "Deaktiviraj"}
                        </Button>
                        <Button  variant="flat" className="btn" bsPrefix="delete" onClick={handleClose}>
                            Otkaži
                        </Button>
                    </Modal.Footer>
                </Form>
            </>
            :
            <div className="loader-container ">
                <Loader />
             </div>
            }
        </Modal>
        </>
    );
};

export default Activate;